import { FC, useEffect } from 'react';
import { PostModalState } from '../../posts-table/model';
import { PostModalForm } from './PostModalForm';
import { PostModalHeader } from './PostModalHeader';

interface Props {
	openModal: PostModalState;
	handleModalClose: () => void;
	setShowErrorToast: (state: boolean) => void;
}

const PostModal: FC<Props> = ({
	openModal,
	handleModalClose,
	setShowErrorToast,
}) => {
	useEffect(() => {
		document.body.classList.add('modal-open');
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, []);

	return (
		<>
			<div
				className='modal fade show d-block'
				id='kt_modal_add_user'
				role='dialog'
				tabIndex={-1}
				aria-modal='true'
			>
				{/* begin::Modal dialog */}
				<div className='modal-dialog modal-dialog-centered mw-650px'>
					{/* begin::Modal content */}
					<div className='modal-content'>
						<PostModalHeader handleModalClose={handleModalClose} />
						{/* begin::Modal body */}
						<div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
							<PostModalForm
								openModal={openModal}
								handleModalClose={handleModalClose}
								setShowErrorToast={setShowErrorToast}
							/>
						</div>
						{/* end::Modal body */}
					</div>
					{/* end::Modal content */}
				</div>
				{/* end::Modal dialog */}
			</div>
			{/* begin::Modal Backdrop */}
			<div
				className='modal-backdrop fade show'
				onClick={handleModalClose}
			></div>
			{/* end::Modal Backdrop */}
		</>
	);
};

export { PostModal };
